module.exports = {"admin":{"newAdmin":["Add a new user","צור משתמש חדש"],"searchByName":["Search admin by name","חפש משתמש לפי שם"],"manager":["Manager","מנהל משרד"],"editor":["Editor","מנהל קמפיינים"],"choosePrivilege":["Choose Privilege","בחר הרשאה"]}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/admin.json
// module id = 436
// module chunks = 0